module.exports = __webpack_public_path__ + "3a47a9c149ece8b6bfeed2b3835d7193.MP3";